module.exports = __webpack_public_path__ + "static/media/happyface-phew.0128ae72.png";